/* v7.7 extras: bottom nav, chat, cookie, exit popup, compare, swatches, load more, tabs, tracking */
(function () {
  'use strict';
  var d = document, root = d.documentElement;
  var design = !!(window.Shopify && window.Shopify.designMode);
  function $(s, c) { return (c || d).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || d).querySelectorAll(s)); }
  function ls(k, v) {
    try {
      if (v === undefined) return localStorage.getItem(k);
      if (v === null) localStorage.removeItem(k); else localStorage.setItem(k, v);
    } catch (e) { return null; }
  }
  function toast(m, err) { if (window.WN && WN.toast) WN.toast(m, err); }
  function reduce() { return window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches; }

  /* ---------- bottom nav ---------- */
  function initBnav() {
    var nav = $('[data-bnav]');
    if (!nav || nav._b) { return; }
    nav._b = true;
    var last = window.pageYOffset, hideOn = nav.getAttribute('data-hide-scroll') === 'true';
    function shown() { return nav.offsetParent !== null && !nav.hasAttribute('data-off'); }
    function measure() {
      if (!shown()) { root.style.setProperty('--bn-off', '0px'); d.body.style.paddingBottom = ''; return; }
      var h = nav.offsetHeight, fl = nav.classList.contains('bnav--floating') ? 10 : 0;
      d.body.style.paddingBottom = (h + fl) + 'px';
      root.style.setProperty('--bn-off', nav.classList.contains('is-hidden') ? '0px' : (h + fl) + 'px');
    }
    measure();
    window.addEventListener('resize', measure);
    if (hideOn) {
      window.addEventListener('scroll', function () {
        var y = window.pageYOffset, dy = y - last;
        if (Math.abs(dy) < 8) return;
        nav.classList.toggle('is-hidden', dy > 0 && y > 240);
        last = y; measure();
      }, { passive: true });
    }
    nav.addEventListener('click', function (e) {
      if (e.target.closest('[data-bnav-search]')) window.scrollTo({ top: 0, behavior: reduce() ? 'auto' : 'smooth' });
    });
  }

  /* ---------- floating chat ---------- */
  function initChat() {
    $$('[data-fchat]').forEach(function (box) {
      if (box._c) return; box._c = true;
      var delay = design ? 0 : parseInt(box.getAttribute('data-delay'), 10) || 0;
      setTimeout(function () { box.classList.add('is-in'); }, delay);
      var t = $('[data-fchat-toggle]', box), menu = $('[data-fchat-menu]', box);
      if (!t || !menu) return;
      t.addEventListener('click', function () {
        var open = menu.hidden;
        menu.hidden = !open;
        t.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      d.addEventListener('click', function (e) {
        if (!box.contains(e.target) && !menu.hidden) { menu.hidden = true; t.setAttribute('aria-expanded', 'false'); }
      });
    });
  }

  /* ---------- cookie banner ---------- */
  function privacy(cb) {
    var S = window.Shopify;
    if (S && S.customerPrivacy && S.customerPrivacy.setTrackingConsent) return cb(S.customerPrivacy);
    if (S && S.loadFeatures) {
      try {
        S.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
          cb(!err && S.customerPrivacy ? S.customerPrivacy : null);
        });
        return;
      } catch (e) {}
    }
    cb(null);
  }
  function initCookie() {
    var el = $('[data-cookie]');
    if (!el || el._k) return; el._k = true;
    var cats = $('[data-cookie-cats]', el), more = $('[data-cookie-more]', el), save = $('[data-cookie-save]', el);
    function show(openCats) {
      el.hidden = false;
      if (openCats) openCat(true);
    }
    function hide() { el.hidden = true; }
    function openCat(on) {
      cats.hidden = !on; save.hidden = !on; more.setAttribute('aria-expanded', on ? 'true' : 'false');
    }
    function decide(c) {
      ls('wn_cc', '1');
      privacy(function (cp) {
        if (cp) {
          try { cp.setTrackingConsent({ analytics: !!c.analytics, marketing: !!c.marketing, preferences: !!c.preferences, sale_of_data: !!c.marketing }, function () {}); } catch (e) {}
        }
      });
      hide();
    }
    el.addEventListener('click', function (e) {
      if (e.target.closest('[data-cookie-accept]')) decide({ analytics: 1, marketing: 1, preferences: 1 });
      else if (e.target.closest('[data-cookie-reject]')) decide({});
      else if (e.target.closest('[data-cookie-more]')) openCat(cats.hidden);
      else if (e.target.closest('[data-cookie-save]')) {
        var c = {}; $$('[data-ck]', el).forEach(function (i) { c[i.getAttribute('data-ck')] = i.checked; }); decide(c);
      }
    });
    d.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href="#cookie-settings"]');
      if (a) { e.preventDefault(); show(true); }
    });
    if (design && el.getAttribute('data-preview') === 'true') { show(false); return; }
    var wait = parseInt(el.getAttribute('data-delay'), 10) || 0;
    privacy(function (cp) {
      var need;
      if (cp && typeof cp.shouldShowBanner === 'function') need = cp.shouldShowBanner();
      else if (cp && typeof cp.currentVisitorConsent === 'function') {
        var v = cp.currentVisitorConsent() || {};
        need = !(v.analytics === 'yes' || v.analytics === 'no' || v.marketing === 'yes' || v.marketing === 'no');
      } else need = !ls('wn_cc');
      if (need && !ls('wn_cc')) setTimeout(function () { show(false); }, wait);
    });
  }

  /* ---------- exit-intent popup ---------- */
  function initXpop() {
    var el = $('[data-xpop]');
    if (!el || el._x) return; el._x = true;
    var key = el.getAttribute('data-key'), days = parseInt(el.getAttribute('data-days'), 10) || 7;
    function open() {
      var ck = $('[data-cookie]');
      if (ck && !ck.hidden) return false;
      el.hidden = false; var c = $('[data-xpop-close]', el); if (c) c.focus(); return true;
    }
    function close() { el.hidden = true; ls(key, String(Date.now())); }
    el.addEventListener('click', function (e) {
      if (e.target.closest('[data-xpop-close]')) close();
      var cp = e.target.closest('.xpop__copy');
      if (cp) { var code = cp.getAttribute('data-copy'); try { navigator.clipboard.writeText(code); cp.textContent = '✓ ' + code; } catch (x) {} }
    });
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !el.hidden) close(); });
    if (design) { if (el.getAttribute('data-editor') === 'true') el.hidden = false; return; }
    var pages = el.getAttribute('data-pages'), pt = el.getAttribute('data-page-type');
    if (pages !== 'all' && pages !== pt) return;
    var seen = parseInt(ls(key), 10);
    if (seen && Date.now() - seen < days * 864e5) return;
    if (/^\/(cart|checkout)/.test(location.pathname) && pages === 'all') return;
    var fired = false;
    function fire() { if (fired) return; if (open()) fired = true; }
    var trig = el.getAttribute('data-trigger'), delay = parseInt(el.getAttribute('data-delay'), 10) || 30000;
    var canHover = window.matchMedia && matchMedia('(hover: hover)').matches;
    if (trig === 'exit' && canHover) {
      var armed = false; setTimeout(function () { armed = true; }, 5000);
      d.addEventListener('mouseout', function (e) { if (armed && !e.relatedTarget && e.clientY <= 0) fire(); });
    } else if (trig === 'scroll') {
      var pct = parseInt(el.getAttribute('data-scroll'), 10) || 50;
      window.addEventListener('scroll', function () {
        var h = root.scrollHeight - window.innerHeight;
        if (h > 0 && window.pageYOffset / h * 100 >= pct) fire();
      }, { passive: true });
    } else {
      setTimeout(function t() { if (!fired && !open()) setTimeout(t, 5000); else fired = true; }, delay);
    }
  }

  /* ---------- swatches on cards ---------- */
  function swPick(btn, link) {
    var card = btn.closest('.product-card'); if (!card) return;
    $$('.pc-sw__i', card).forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
    var src = btn.getAttribute('data-sw-img'), img = $('.product-card__img:not(.product-card__img--hover)', card);
    if (src && img) { img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = src; card.classList.add('has-sw'); }
    if (link) {
      var u = btn.getAttribute('data-sw-url');
      $$('.product-card__media, .product-card__title a, a.product-card__add', card).forEach(function (a) { a.setAttribute('href', u); });
    }
  }
  d.addEventListener('click', function (e) { var b = e.target.closest && e.target.closest('.pc-sw__i'); if (b) { e.preventDefault(); swPick(b, true); } });
  d.addEventListener('mouseover', function (e) {
    if (!(window.matchMedia && matchMedia('(hover: hover)').matches)) return;
    var b = e.target.closest && e.target.closest('.pc-sw__i'); if (b) swPick(b, false);
  });

  /* ---------- load more / infinite ---------- */
  function initLoadMore() {
    $$('[data-loadmore]').forEach(function (box) {
      if (box._lm) return; box._lm = true;
      var btn = $('[data-lm-btn]', box), status = $('[data-lm-status]', box), bar = $('[data-lm-bar]', box);
      var busy = false, io;
      if (!btn) return;
      function load() {
        var url = box.getAttribute('data-next');
        if (!url || busy) return;
        busy = true; btn.classList.add('is-loading');
        var label = btn.textContent; btn.textContent = btn.getAttribute('data-loading') || label;
        fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var grid = $('[data-product-grid]'), ng = $('[data-product-grid]', doc);
          if (grid && ng) Array.prototype.slice.call(ng.children).forEach(function (li) { grid.appendChild(d.importNode(li, true)); });
          var nb = $('[data-loadmore]', doc), next = nb ? nb.getAttribute('data-next') : '';
          var seen = nb ? parseInt(nb.getAttribute('data-seen'), 10) : 0, total = parseInt(box.getAttribute('data-total'), 10) || 0;
          box.setAttribute('data-next', next || '');
          if (status) status.textContent = (box.getAttribute('data-text') || '').replace('[n]', seen).replace('[t]', total);
          if (bar && total) bar.style.width = Math.min(100, seen * 100 / total) + '%';
          btn.textContent = label; btn.classList.remove('is-loading'); busy = false;
          if (!next) { btn.remove(); if (io) io.disconnect(); }
          d.dispatchEvent(new CustomEvent('wn:cards'));
          d.dispatchEvent(new CustomEvent('shopify:section:load'));
        }).catch(function () { btn.textContent = label; btn.classList.remove('is-loading'); busy = false; });
      }
      btn.addEventListener('click', load);
      if (box.getAttribute('data-mode') === 'infinite' && 'IntersectionObserver' in window && !design) {
        io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) load(); }, { rootMargin: '700px 0px' });
        io.observe(btn);
      }
    });
  }

  /* ---------- collection tabs ---------- */
  d.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-ctab]'); if (!t) return;
    var s = t.closest('[data-ctabs]'), i = t.getAttribute('data-ctab');
    $$('[data-ctab]', s).forEach(function (b) { var on = b === t; b.classList.toggle('is-on', on); b.setAttribute('aria-selected', on ? 'true' : 'false'); });
    $$('[data-cpanel]', s).forEach(function (p) { p.classList.toggle('is-on', p.getAttribute('data-cpanel') === i); });
  });

  /* ---------- order tracking ---------- */
  d.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('[data-track-form]'); if (!f) return;
    e.preventDefault();
    var n = $('[data-track-num]', f).value.replace(/\s+/g, ''), c = $('[data-track-carrier]', f).value, err = $('[data-track-err]', f);
    if (!/^[A-Za-z0-9\-]{6,40}$/.test(n)) { err.hidden = false; return; }
    err.hidden = true;
    var en = encodeURIComponent(n);
    var map = {
      dhl: 'https://www.dhl.de/de/privatkunden/dhl-sendungsverfolgung.html?piececode=' + en,
      dpd: 'https://tracking.dpd.de/status/de_DE/parcel/' + en,
      hermes: 'https://www.myhermes.de/empfangen/sendungsverfolgung/sendungsinformation/#' + en,
      gls: 'https://gls-group.com/DE/de/paketverfolgung?match=' + en,
      ups: 'https://www.ups.com/track?loc=de_DE&tracknum=' + en,
      '17track': 'https://t.17track.net/de#nums=' + en
    };
    window.open(map[c] || map['17track'], '_blank', 'noopener');
  });

  /* ---------- compare ---------- */
  var cmpCache = {};
  function cmpList() { try { return JSON.parse(ls('wn_cmp') || '[]'); } catch (e) { return []; } }
  function cmpSave(l) { ls('wn_cmp', JSON.stringify(l)); }
  function money(c) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    try { return new Intl.NumberFormat(root.lang || 'de', { style: 'currency', currency: cur }).format(c / 100); } catch (e) { return (c / 100).toFixed(2) + ' ' + cur; }
  }
  function getProd(h) {
    if (cmpCache[h]) return Promise.resolve(cmpCache[h]);
    return fetch('/products/' + encodeURIComponent(h) + '.js').then(function (r) { if (!r.ok) throw 0; return r.json(); }).then(function (p) { cmpCache[h] = p; return p; });
  }
  function cmpUI() { return $('[data-compare-ui]'); }
  function esc(s) { var x = d.createElement('div'); x.textContent = s == null ? '' : s; return x.innerHTML; }
  function cmpSync() {
    var l = cmpList();
    $$('[data-compare]').forEach(function (b) {
      var on = l.indexOf(b.getAttribute('data-handle')) > -1;
      b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var ui = cmpUI(); if (!ui) return;
    var bar = $('[data-compare-bar]', ui), th = $('[data-compare-thumbs]', ui);
    $('[data-compare-n]', ui).textContent = l.length;
    bar.hidden = l.length === 0;
    th.innerHTML = '';
    l.forEach(function (h) {
      getProd(h).then(function (p) {
        if (p.featured_image) { var i = new Image(); i.src = p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_100x100$1$2'); i.alt = p.title; th.appendChild(i); }
      }).catch(function () {});
    });
  }
  function cmpOpen() {
    var ui = cmpUI(), l = cmpList(); if (!ui || !l.length) return;
    var a = function (k) { return ui.getAttribute('data-' + k); };
    Promise.all(l.map(function (h) { return getProd(h).catch(function () { return null; }); })).then(function (ps) {
      ps = ps.filter(Boolean);
      var rows = '';
      function row(label, fn) { rows += '<tr><th scope="row">' + esc(label) + '</th>' + ps.map(function (p) { return '<td>' + fn(p) + '</td>'; }).join('') + '</tr>'; }
      rows += '<tr><td></td>' + ps.map(function (p) {
        return '<td>' + (p.featured_image ? '<img src="' + p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_400x400$1$2') + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '<strong>' + esc(p.title) + '</strong><br><a class="cmp__view" href="' + p.url + '">' + esc(a('l-view')) + '</a><button type="button" class="cmp__rm" data-compare-rm="' + p.handle + '">× ' + esc(a('l-clear')) + '</button></td>';
      }).join('') + '</tr>';
      row(a('l-price'), function (p) { return '<strong>' + money(p.price) + '</strong>' + (p.compare_at_price > p.price ? ' <s>' + money(p.compare_at_price) + '</s>' : ''); });
      if (a('show-vendor') === 'true') row(a('l-vendor'), function (p) { return esc(p.vendor); });
      row(a('l-avail'), function (p) { return esc(p.available ? a('l-yes') : a('l-no')); });
      if (a('show-desc') === 'true') row(a('l-desc'), function (p) { var t = (p.description || '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim(); return esc(t.length > 170 ? t.slice(0, 167) + '…' : t); });
      if (a('show-options') === 'true') row(a('l-options'), function (p) { return (p.options || []).map(function (o) { return esc(o.name) + ': ' + esc((o.values || []).join(', ')); }).join('<br>'); });
      $('[data-compare-table]', ui).innerHTML = '<table class="cmp__t"><tbody>' + rows + '</tbody></table>';
      $('[data-compare-modal]', ui).hidden = false;
    });
  }
  d.addEventListener('click', function (e) {
    var t = e.target, b;
    if ((b = t.closest && t.closest('[data-compare]'))) {
      e.preventDefault();
      var h = b.getAttribute('data-handle'), l = cmpList(), i = l.indexOf(h), ui = cmpUI();
      var max = ui ? parseInt(ui.getAttribute('data-max'), 10) || 3 : 3;
      if (i > -1) l.splice(i, 1);
      else { if (l.length >= max) { toast((ui && ui.getAttribute('data-l-max') ? ui.getAttribute('data-l-max') : '') + ' (' + max + ')', true); return; } l.push(h); }
      cmpSave(l); cmpSync(); return;
    }
    if (t.closest && t.closest('[data-compare-open]')) { cmpOpen(); return; }
    if (t.closest && t.closest('[data-compare-clear]')) { cmpSave([]); cmpSync(); return; }
    if (t.closest && t.closest('[data-compare-close]')) { var m = $('[data-compare-modal]'); if (m) m.hidden = true; return; }
    if ((b = t.closest && t.closest('[data-compare-rm]'))) {
      var l2 = cmpList().filter(function (x) { return x !== b.getAttribute('data-compare-rm'); }); cmpSave(l2); cmpSync();
      if (l2.length) cmpOpen(); else { var mm = $('[data-compare-modal]'); if (mm) mm.hidden = true; }
    }
  });
  d.addEventListener('keydown', function (e) { if (e.key === 'Escape') { var m = $('[data-compare-modal]'); if (m && !m.hidden) m.hidden = true; } });

  function init() { initBnav(); initChat(); initCookie(); initXpop(); initLoadMore(); cmpSync(); }
  d.addEventListener('shopify:section:load', init);
  d.addEventListener('wn:cards', cmpSync);
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})();

/* v7.9: video banner – no video on mobile when an image fallback is set; scroll-down arrow */
(function () {
  var d = document;
  function mobileCut() {
    if (!(window.matchMedia && matchMedia('(max-width: 749px)').matches)) return;
    [].forEach.call(d.querySelectorAll('[data-vb-nomobile] .vbanner__vid'), function (v) { if (v.parentNode) v.parentNode.removeChild(v); });
  }
  d.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-scroll-next]'); if (!b) return;
    var w = b.closest('.shopify-section'), n = w && w.nextElementSibling;
    if (n) n.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
  mobileCut();
  d.addEventListener('shopify:section:load', mobileCut);
})();
